module.exports = __webpack_public_path__ + "img/right.d887722b.svg";